
import SeasonDashboard from '@/components/SeasonDashboard.component.vue'

export default {
  name: 'SeasonDashboardPage',
  components: {
    SeasonDashboard
  }
}
